import type { PipeTransform } from '@angular/core'
import { Pipe } from '@angular/core'

const prefixSlash = (txt: string): string => (txt.startsWith('/') ? txt : '/' + txt)
const removeSlash = (urlChunk: string): string => (urlChunk.startsWith('/') ? urlChunk.slice(1) : urlChunk)

@Pipe({ name: 'addNextPrefix' })
export class AddNextPrefixPipe implements PipeTransform {
  transform(value: string[] | string): string[] | string {
    return Array.isArray(value) ? this.transformArray(value) : this.transformSingle(value)
  }

  private transformArray(chunks: string[]) {
    const [first] = chunks
    if (this.containsUrlPrefix(first)) {
      return chunks
    }

    const url = ['/next', ...chunks.map(removeSlash)].join('/')
    return [url]
  }

  private containsUrlPrefix(url: string | undefined) {
    return url && (url.startsWith('next') || url.startsWith('/next'))
  }

  private transformSingle(url: string): string {
    if (this.containsUrlPrefix(url)) {
      return url
    }
    return '/next' + prefixSlash(url)
  }
}
